import { Button } from '@shared/ui/button'
import { Link } from '@tanstack/react-router'

export function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-bg-base px-6">
      <div className="text-center">
        <p className="typo-heading font-bold text-foreground">페이지를 찾을 수 없어요</p>
        <p className="mt-2 typo-label text-muted-foreground">
          주소를 다시 확인하거나, 홈에서 시작해 주세요
        </p>
      </div>
      <Link to="/saju/$sajuType" params={{ sajuType: 'classic' }}>
        <Button variant="primary" size="lg">
          홈으로 돌아가기
        </Button>
      </Link>
    </div>
  )
}
